<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAll"></b-form-checkbox>
        <span @click="checkedAll = !checkedAll">Komoot Trail View</span>
        <div style="float: right;">
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;" :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
      </div>
    </div>    
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.komoottrailview]" :key="place.id" :place="place"></MapPlace>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import Place from '@/ts/Place';
import Photo from '@/ts/Photo';
import PlaceType from '@/ts/PlaceType';
import { AlertStatus, DataOrigin, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAll: boolean = false;

        return {
            checkedAll,
            expanded: false,
            active: true,
            inactive: false,
            loading: false
        };
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadPlacesKomootTrailView());
      EventBus.$on('toggleKomootTrailView', () => {
        if (this.$options.result) {
          this.checkedAll = !this.checkedAll;
        }
      });
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
    },
    methods: {
      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      onSelectedAreaChanged(newArea: string, oldArea: string) {
        if (this.$options.places) {
          for (const place of this.$options.places) {
            try { place.getMarker().removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.result) {
          this.processPlacesKomootTrailView();
        }
      },
        downloadPlacesKomootTrailView() {
            this.loading = true;
            const endPoint = window.apiHost + 'api/stringfield/komoottrailview/';
            this.downloadUrlWithCache(endPoint, 'komoottrailview', 'komoottrailview.txt', null, true).then((response) => {
              this.$options.result = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
            }).finally(() => {
              this.loading = false;
            });
        },
        processPlacesKomootTrailView() {
            const places: Place[] = [];
            const other_type = new PlaceType(1000001, 'other', {'color': 'blue'}, 1);
            for (const responsePlace of this.$options.result) {
              const placetype = other_type;
              const place = new Place(responsePlace.id, responsePlace.id, '', responsePlace.lat.toFixed(5), responsePlace.lon.toFixed(5), placetype, false, null, DataOrigin.komoottrailview, responsePlace.is_active);
              place.createMarker();
              const photo = new Photo(responsePlace.id, 'Photo', '', responsePlace.id, null, window.mediaHost + 'komoot_trail_view/' + responsePlace.id + '.jpg', window.mediaHost + 'komoot_trail_view/' + responsePlace.id + '.jpg', window.mediaHost + 'komoot_trail_view/' + responsePlace.id + '_thumb.jpg', false, 1, false);
              place.addPhoto(photo);
              if (this.isPointInSelectedArea(place.lat, place.lon)) {
                places.push(place);
              }
            }
            this.$options.places = places;
            window.externalPlaces.komoottrailview = this.$options.places;
            this.onCheckedAllChanged();
        },
        onCheckedAllChanged() {
            if (this.$options.places) {
              for(const place of this.$options.places) {
                if (this.checkedAll) {
                  if (place.is_active) {
                    if (this.active) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactive) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  }
                } else {
                  place.getMarker().removeFrom(window.mainmap);
                }
              }
            } else {
              this.processPlacesKomootTrailView();
            }
        }
    },
    watch: {
        "checkedAll": [{
            handler: "onCheckedAllChanged"
        }],
        "active": [{
            handler: "onCheckedAllChanged"
        }],
        "inactive": [{
            handler: "onCheckedAllChanged"
        }]
    }
})


</script>